import { Box, Button, MenuItem, Typography } from '@mui/material'
import clsx from 'clsx'
import { useStyles } from './styles'
import { useState } from 'react'
import useTranslations from '../../../i18n/useTranslations'
import useIsMobile from '../../../hooks/useIsMobile'
import Select from '../../../ui/components/select'

const ReportConfig = ({}) => {
  const classes = useStyles()
  const t = useTranslations()
  const isMobile = useIsMobile()
  const [selected, setSelected] = useState(0)

  const [days, setDays] = useState([])
  const [day, setDay] = useState('none')
  const [week, setWeek] = useState('none')
  const [hour, setHour] = useState('none')

  const onClickConfirm = async () => {}
  const daysWeek = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom']
  const weeksInMonth = ['Primera', 'Segunda', 'Tercera', 'Cuarta']
  const daysWeekComplete = [
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
    'Domingo',
  ]
  const hours = [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '21:00',
    '22:00',
    '23:00',
  ]

  const renderContent = () => {
    return (
      <Box className={classes.pickUpContent}>
        {selected === 0 ? (
          <Box className={classes.inputsBox}>
            <Typography className={clsx('secondaryTitle', classes.title)}>
              {t('reports:days')}
            </Typography>
            {daysWeek.map((e, index) => {
              return (
                <Button
                  key={index}
                  size="small"
                  variant={days.indexOf(e) >= 0 ? 'contained' : 'outlined'}
                  onClick={() => {
                    let daysAux = days.slice()
                    if (daysAux.indexOf(e) >= 0) {
                      daysAux.splice(daysAux.indexOf(e), 1)
                    } else {
                      daysAux.push(e)
                    }
                    setDays(daysAux)
                  }}
                >
                  {e}
                </Button>
              )
            })}
          </Box>
        ) : null}
        {selected === 2 ? (
          <Box className={classes.inputsBox}>
            <Select
              label={t('reports:week')}
              labelId="pick-up-timetable"
              name="pickupSchedule"
              className={
                isMobile
                  ? clsx('input-full', classes.marginInput)
                  : clsx('input-small', classes.marginInput)
              }
              value={week}
              defaultValue="none"
              onChange={event => {
                setWeek(event.target.value)
              }}
            >
              {weeksInMonth.map(e => {
                return (
                  <MenuItem key={e} value={e}>
                    <em>{e}</em>
                  </MenuItem>
                )
              })}
              <MenuItem disabled value="none">
                <em>{t('shipping-send-form:origin:pickup:choose-schedule')}</em>
              </MenuItem>
            </Select>
            <Select
              label={t('reports:day')}
              labelId="pick-up-timetable"
              name="pickupSchedule"
              className={
                isMobile
                  ? clsx('input-full', classes.marginInput)
                  : clsx('input-small', classes.marginInput)
              }
              value={day}
              defaultValue="none"
              onChange={event => {
                setDay(event.target.value)
              }}
            >
              {daysWeekComplete.map(e => {
                return (
                  <MenuItem key={e} value={e}>
                    <em>{e}</em>
                  </MenuItem>
                )
              })}
              <MenuItem disabled value="none">
                <em>{t('shipping-send-form:origin:pickup:choose-schedule')}</em>
              </MenuItem>
            </Select>
          </Box>
        ) : null}
        <Box className={classes.pickUpContent}>
          <Select
            label={t('reports:hour')}
            labelId="pick-up-timetable"
            name="pickupSchedule"
            className={
              isMobile
                ? clsx('input-full', classes.marginInput)
                : clsx('input-small', classes.marginInput)
            }
            value={hour}
            defaultValue="none"
            onChange={event => {
              setHour(event.target.value)
            }}
          >
            {hours.map(e => {
              return (
                <MenuItem key={e} value={e}>
                  <em>{e}</em>
                </MenuItem>
              )
            })}
            <MenuItem disabled value="none">
              <em>{t('shipping-send-form:origin:pickup:choose-schedule')}</em>
            </MenuItem>
          </Select>
        </Box>
      </Box>
    )
  }

  return (
    <Box component="section" sx={classes.section}>
      <Typography className={clsx('secondaryTitle', classes.title)}>
        {t('reports:frequency')}
      </Typography>

      <Box sx={classes.buttonsWrapper}>
        <Button
          size="small"
          variant={selected === 0 ? 'contained' : 'outlined'}
          onClick={() => {
            setSelected(0)
          }}
        >
          {t('reports:daily')}
        </Button>

        <Button
          size="small"
          variant={selected === 1 ? 'contained' : 'outlined'}
          onClick={() => {
            setSelected(1)
          }}
        >
          {t('reports:weekly')}
        </Button>
        <Button
          size="small"
          variant={selected === 2 ? 'contained' : 'outlined'}
          onClick={() => {
            setSelected(2)
          }}
        >
          {t('reports:month')}
        </Button>
      </Box>

      {renderContent()}

      <Box className={classes.buttonsGroup}>
        <Button
          variant="outlined"
          className={classes.marginInput}
          size={'small'}
          onClick={() => null}
        >
          {t('action:cancel')}
        </Button>
        <Button
          size={'small'}
          disabled={selected === 1 && hour === 'none'}
          onClick={onClickConfirm}
        >
          {t('action:import-file')}
        </Button>
      </Box>
    </Box>
  )
}

ReportConfig.propTypes = {}

export default ReportConfig
